export var EquipmentCategory;
(function (EquipmentCategory) {
    EquipmentCategory["GRINDERS"] = "grinders";
    EquipmentCategory["BREWING_DEVICES"] = "brewing_devices";
    EquipmentCategory["ESPRESSO_MACHINES"] = "espresso_machines";
    EquipmentCategory["ACCESSORIES"] = "accessories";
    EquipmentCategory["SCALES"] = "scales";
    EquipmentCategory["KETTLES"] = "kettles";
    EquipmentCategory["FILTERS"] = "filters";
    EquipmentCategory["STORAGE"] = "storage";
})(EquipmentCategory || (EquipmentCategory = {}));
export var EquipmentType;
(function (EquipmentType) {
    // Grinders
    EquipmentType["BURR_GRINDER"] = "burr_grinder";
    EquipmentType["BLADE_GRINDER"] = "blade_grinder";
    EquipmentType["HAND_GRINDER"] = "hand_grinder";
    // Brewing Devices
    EquipmentType["POUR_OVER_DRIPPER"] = "pour_over_dripper";
    EquipmentType["FRENCH_PRESS"] = "french_press";
    EquipmentType["AEROPRESS"] = "aeropress";
    EquipmentType["CHEMEX"] = "chemex";
    EquipmentType["V60"] = "v60";
    EquipmentType["COLD_BREW_MAKER"] = "cold_brew_maker";
    // Espresso
    EquipmentType["ESPRESSO_MACHINE"] = "espresso_machine";
    EquipmentType["PORTAFILTER"] = "portafilter";
    EquipmentType["TAMPER"] = "tamper";
    // Accessories
    EquipmentType["SCALE"] = "scale";
    EquipmentType["KETTLE"] = "kettle";
    EquipmentType["THERMOMETER"] = "thermometer";
    EquipmentType["TIMER"] = "timer";
    EquipmentType["FILTER"] = "filter";
    EquipmentType["STORAGE_CONTAINER"] = "storage_container";
})(EquipmentType || (EquipmentType = {}));
